module.exports = __webpack_public_path__ + "media/images/lb/234-2b320e44dd5afc958b3c340f19a5a369.svg";